import { useState, useCallback } from 'react';
import Toast, { ToastType } from './Toast';

export interface ToastItem {
  id: number;
  message: string;
  type: ToastType;
}

interface ToastContainerProps {
  toasts: ToastItem[];
  onRemove: (id: number) => void;
}

const ToastContainer = ({ toasts, onRemove }: ToastContainerProps) => (
  <div className="fixed top-6 right-6 z-[9999] flex flex-col gap-3 items-end">
    {toasts.map((t) => (
      <Toast key={t.id} message={t.message} type={t.type} onClose={() => onRemove(t.id)} />
    ))}
  </div>
);

export const useToast = () => {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  const addToast = useCallback((message: string, type: ToastType = 'info') => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, message, type }]);
  }, []);

  const removeToast = useCallback((id: number) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return { toasts, addToast, removeToast };
};

export default ToastContainer;
